import { css as _css } from "@emotion/core";
import React from 'react';
import PropTypes from 'prop-types';
import ListingModel from '../../models/listing';
import SmallCard from '../small-card';
import * as styles from './horizontal-slide.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var HorizontalSlide = _ref => {
  var listings = _ref.listings,
    title = _ref.title,
    _onClick = _ref.onClick,
    noScroll = _ref.noScroll,
    Component = _ref.component;
  return ___EmotionJSX("div", {
    css: /*#__PURE__*/_css([styles.horizontalSlide, !noScroll && styles.scroll])
  }, listings.map((listing, index) => ___EmotionJSX(Component, {
    key: listing.url,
    title: title,
    listing: listing,
    onClick: () => {
      _onClick(listing, index);
    }
  })));
};
HorizontalSlide.propTypes = {
  listings: PropTypes.arrayOf(PropTypes.shape(ListingModel)),
  onClick: PropTypes.func,
  title: PropTypes.string,
  component: PropTypes.elementType,
  noScroll: PropTypes.bool
};
HorizontalSlide.defaultProps = {
  listings: [],
  onClick: () => {},
  title: 'Property of the Week',
  component: SmallCard,
  noScroll: false
};
export default HorizontalSlide;